import { City } from './city.model';

export const cities: City[] = [
  {
    ID: 1,
    Name: 'Αθήνα',
    CityName: 'Αθήνα',
    PrefectureId: '1',
    NomosID: 1,
    Nomos: 'Αττική',
  },
  {
    ID: 2,
    Name: 'Θεσσαλονίκη',
    CityName: 'Θεσσαλονίκη',
    PrefectureId: '2',
    NomosID: 2,
    Nomos: 'Κεντρική Μακεδονία',
  },
  {
    ID: 3,
    Name: 'Πάτρα',
    CityName: 'Πάτρα',
    PrefectureId: '3',
    NomosID: 3,
    Nomos: 'Δυτική Ελλάδα',
  },
  {
    ID: 4,
    Name: 'Ηράκλειο',
    CityName: 'Ηράκλειο',
    PrefectureId: '4',
    NomosID: 4,
    Nomos: 'Κρήτη',
  },
  {
    ID: 5,
    Name: 'Λάρισα',
    CityName: 'Λάρισα',
    PrefectureId: '5',
    NomosID: 5,
    Nomos: 'Θεσσαλία',
  },
  {
    ID: 6,
    Name: 'Βόλος',
    CityName: 'Βόλος',
    PrefectureId: '6',
    NomosID: 6,
    Nomos: 'Θεσσαλία',
  },
  {
    ID: 7,
    Name: 'Ιωάννινα',
    CityName: 'Ιωάννινα',
    PrefectureId: '7',
    NomosID: 7,
    Nomos: 'Ήπειρος',
  },
  {
    ID: 8,
    Name: 'Χανιά',
    CityName: 'Χανιά',
    PrefectureId: '8',
    NomosID: 8,
    Nomos: 'Κρήτη',
  },
  {
    ID: 9,
    Name: 'Καβάλα',
    CityName: 'Καβάλα',
    PrefectureId: '9',
    NomosID: 9,
    Nomos: 'Ανατολική Μακεδονία και Θράκη',
  },
  {
    ID: 10,
    Name: 'Καλαμάτα',
    CityName: 'Καλαμάτα',
    PrefectureId: '10',
    NomosID: 10,
    Nomos: 'Πελοπόννησος',
  },
  {
    ID: 11,
    Name: 'Ρόδος',
    CityName: 'Ρόδος',
    PrefectureId: '11',
    NomosID: 11,
    Nomos: 'Νότιο Αιγαίο',
  },
  {
    ID: 12,
    Name: 'Σέρρες',
    CityName: 'Σέρρες',
    PrefectureId: '12',
    NomosID: 12,
    Nomos: 'Κεντρική Μακεδονία',
  },
  {
    ID: 13,
    Name: 'Τρίκαλα',
    CityName: 'Τρίκαλα',
    PrefectureId: '13',
    NomosID: 13,
    Nomos: 'Θεσσαλία',
  },
  {
    ID: 14,
    Name: 'Ξάνθη',
    CityName: 'Ξάνθη',
    PrefectureId: '14',
    NomosID: 14,
    Nomos: 'Ανατολική Μακεδονία και Θράκη',
  },
  {
    ID: 15,
    Name: 'Κομοτηνή',
    CityName: 'Κομοτηνή',
    PrefectureId: '15',
    NomosID: 15,
    Nomos: 'Ανατολική Μακεδονία και Θράκη',
  },
  {
    ID: 16,
    Name: 'Καρδίτσα',
    CityName: 'Καρδίτσα',
    PrefectureId: '16',
    NomosID: 16,
    Nomos: 'Θεσσαλία',
  },
  {
    ID: 17,
    Name: 'Ρέθυμνο',
    CityName: 'Ρέθυμνο',
    PrefectureId: '17',
    NomosID: 17,
    Nomos: 'Κρήτη',
  },
  {
    ID: 18,
    Name: 'Άγιος Νικόλαος',
    CityName: 'Άγιος Νικόλαος',
    PrefectureId: '18',
    NomosID: 18,
    Nomos: 'Κρήτη',
  },
  {
    ID: 19,
    Name: 'Κέρκυρα',
    CityName: 'Κέρκυρα',
    PrefectureId: '19',
    NomosID: 19,
    Nomos: 'Ιόνια Νησιά',
  },
  {
    ID: 20,
    Name: 'Λαμία',
    CityName: 'Λαμία',
    PrefectureId: '20',
    NomosID: 20,
    Nomos: 'Στερεά Ελλάδα',
  },
  {
    ID: 21,
    Name: 'Κόρινθος',
    CityName: 'Κόρινθος',
    PrefectureId: '21',
    NomosID: 21,
    Nomos: 'Πελοπόννησος',
  },
  {
    ID: 22,
    Name: 'Πρέβεζα',
    CityName: 'Πρέβεζα',
    PrefectureId: '22',
    NomosID: 22,
    Nomos: 'Ήπειρος',
  },
  {
    ID: 23,
    Name: 'Κιλκίς',
    CityName: 'Κιλκίς',
    PrefectureId: '23',
    NomosID: 23,
    Nomos: 'Κεντρική Μακεδονία',
  },
  {
    ID: 24,
    Name: 'Πτολεμαΐδα',
    CityName: 'Πτολεμαΐδα',
    PrefectureId: '24',
    NomosID: 24,
    Nomos: 'Δυτική Μακεδονία',
  },
  {
    ID: 25,
    Name: 'Άρτα',
    CityName: 'Άρτα',
    PrefectureId: '25',
    NomosID: 25,
    Nomos: 'Ήπειρος',
  },
  {
    ID: 26,
    Name: 'Βέροια',
    CityName: 'Βέροια',
    PrefectureId: '26',
    NomosID: 26,
    Nomos: 'Κεντρική Μακεδονία',
  },
  {
    ID: 27,
    Name: 'Καστοριά',
    CityName: 'Καστοριά',
    PrefectureId: '27',
    NomosID: 27,
    Nomos: 'Δυτική Μακεδονία',
  },
  {
    ID: 28,
    Name: 'Κατερίνη',
    CityName: 'Κατερίνη',
    PrefectureId: '28',
    NomosID: 28,
    Nomos: 'Κεντρική Μακεδονία',
  },
  {
    ID: 29,
    Name: 'Λιβαδειά',
    CityName: 'Λιβαδειά',
    PrefectureId: '29',
    NomosID: 29,
    Nomos: 'Στερεά Ελλάδα',
  },
  {
    ID: 30,
    Name: 'Ναύπλιο',
    CityName: 'Ναύπλιο',
    PrefectureId: '30',
    NomosID: 30,
    Nomos: 'Πελοπόννησος',
  },
];
